import { CloseButton } from "../../close-button";

import successImageUrl from "../../../assets/success.svg";

interface FeedbackSuccessStepProps {
  onFeedbackRestartRequested: () => void;
}

export function FeedbackSuccessStep({
  onFeedbackRestartRequested,
}: FeedbackSuccessStepProps) {
  return (
    <>
      <header className="w-full flex justify-end">
        <CloseButton />
      </header>

      <div className="flex flex-col items-center py-12 w-[304px] animate-fade-in">
        <div className="relative">
          <div className="absolute inset-0 bg-brand-500/20 blur-xl rounded-full" />
          <img
            src={successImageUrl}
            alt="Imagem de enviado com sucesso"
            className="w-12 h-12 relative z-10 transition-transform duration-500 hover:scale-110"
          />
        </div>

        <span className="text-xl mt-4 font-medium text-zinc-100">
          Agradecemos o feedback!
        </span>
        <p className="text-sm text-zinc-400 mt-2 text-center px-4">
          Sua opinião é muito importante para nós.
        </p>

        <button
          type="button"
          title="Enviar outro feedback"
          aria-labelledby="Enviar outro feedback"
          onClick={onFeedbackRestartRequested}
          className="py-2 px-6 mt-6 bg-zinc-800 rounded-md border-transparent text-sm leading-6 hover:bg-zinc-700 text-zinc-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-zinc-900 focus:ring-brand-500 transition-all duration-200 ease-in-out shadow-md hover:shadow-lg border border-zinc-700 hover:border-zinc-600"
        >
          Quero enviar outro
        </button>
      </div>
    </>
  );
}
